interface UpdatedAtProps {
  updatedLabel?: string; // formatted string for span
  pushedAtFormatted?: string; // formatted string for tool tip
}

export default function UpdatedAt({updatedLabel, pushedAtFormatted}: UpdatedAtProps) {
  if(!updatedLabel || updatedLabel === 'nan') {
    return null;
  }

  const updatedSpan = <span>Updated {updatedLabel}</span>;
  
  if (!pushedAtFormatted) {
    // no tooltip if updated this week
    return updatedSpan;
  } else {
    return (
      <span className="tooltip">
        <span className="tooltip-content">{pushedAtFormatted}</span>
        {updatedSpan}
      </span>
    )
  }
}